/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DirectoryReviewSettings,
  DirectoryReviewSettings$Outbound,
  DirectoryReviewSettings$outboundSchema,
} from "../components/directoryreviewsettings.js";

export type UpdateDirectoryReviewSettingsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateDirectoryReviewSettingsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  directoryReviewSettings: DirectoryReviewSettings;
};

/** @internal */
export type UpdateDirectoryReviewSettingsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateDirectoryReviewSettingsSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateDirectoryReviewSettingsSecurity$Outbound,
    UpdateDirectoryReviewSettingsSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateDirectoryReviewSettingsSecurityToJSON(
  updateDirectoryReviewSettingsSecurity: UpdateDirectoryReviewSettingsSecurity,
): string {
  return JSON.stringify(
    UpdateDirectoryReviewSettingsSecurity$outboundSchema.parse(
      updateDirectoryReviewSettingsSecurity,
    ),
  );
}

/** @internal */
export type UpdateDirectoryReviewSettingsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  DirectoryReviewSettings: DirectoryReviewSettings$Outbound;
};

/** @internal */
export const UpdateDirectoryReviewSettingsRequest$outboundSchema: z.ZodMiniType<
  UpdateDirectoryReviewSettingsRequest$Outbound,
  UpdateDirectoryReviewSettingsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    directoryReviewSettings: DirectoryReviewSettings$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      directoryReviewSettings: "DirectoryReviewSettings",
    });
  }),
);

export function updateDirectoryReviewSettingsRequestToJSON(
  updateDirectoryReviewSettingsRequest: UpdateDirectoryReviewSettingsRequest,
): string {
  return JSON.stringify(
    UpdateDirectoryReviewSettingsRequest$outboundSchema.parse(
      updateDirectoryReviewSettingsRequest,
    ),
  );
}
